/** Origin MS.OrganizationService (không có `/api`) — dùng axios dev gọi thẳng khi bật NEXT_PUBLIC_*. */
export const resolveOrgApiOrigin = (): string => {
  const raw =
    process.env.NEXT_PUBLIC_ORG_API_ORIGIN?.trim() ||
    process.env.NEXT_PUBLIC_ORG_API_BASE_URL?.trim() ||
    process.env.CONFIG_NEXT_PUBLIC_ORG_API_BASE_URL?.trim() ||
    '';
  if (raw) {
    return raw.replace(/\/$/, '').replace(/\/api$/i, '');
  }
  return '';
};

export const isOrganizationApiPath = (url: string | undefined): boolean => {
  if (!url) return false;
  const path = url.startsWith('http') ? new URL(url, 'http://local').pathname : url;
  return /^\/v1\/(employee|position|department|organization|rolegroup|nhanvienonleave|cocau-giai-doan)\b/i.test(path);
};
